import React, { Component } from 'react'

// import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
// import Typography from '@material-ui/core/Typography'
// import Select from '@material-ui/core/Select'
// import MenuItem from '@material-ui/core/MenuItem'

// import { bindActionCreators } from 'redux'
// import { connect } from 'react-redux'
// import { push } from 'connected-react-router'

import SummaryContent from './data_visualizer/SummaryContent'
import TableContent from './data_visualizer/TableContent'
import DetailContent from './data_visualizer/DetailContent'

import { dataVisualizerMode } from './../../../libs/DataUtilities'

import './DataVisualizer.css'

/*
const styles = theme => ({
    title: {
        color: theme.palette.text.primary
    },
    bigSelect: {
        ...theme.typography.display2,
        color: theme.palette.text.primary
    },
    bigSelectSelectMenu: {
        whiteSpace: 'unset'
    }
  });
*/

class DataVisualizer extends Component {

    /* Handlers */

    /* Lifecycle */
     
    render() {

        // const { classes } = this.props
        const { region, dataType, source } = this.props.comparator
        const { currentSelectionChange } = this.props

        const mode = dataVisualizerMode(region, dataType)

        let content = null

        switch (mode) {
            case 'summary':
                content = <SummaryContent region={region} 
                                          data={this.props.data}
                                          currentSelection={this.props.currentSelection}
                                          detailHover={(dataType, direction) => {
                                            direction == 'enter' ? currentSelectionChange(null, dataType, null) : currentSelectionChange(null, null, null) 
                                          }}/>
                break;
            case 'table':
                content = <TableContent dataType={dataType} 
                                        data={this.props.data} 
                                        currentSelection={this.props.currentSelection}
                                        rowHover={(region, direction) => { 
                                            direction == 'enter' ? currentSelectionChange(region, null, null) : currentSelectionChange(null, null, null) 
                                        }}/>
                break;
            case 'detail':
                content = <DetailContent region={region} dataType={dataType} data={this.props.data}/>
                break;
        }

        return (
            <div className="pages-shared-data-visualizer">
                <br/>
                <Grid container spacing={16}>
                    <Hidden only={["xs", "sm"]}>
                        <Grid item sm={1}></Grid>
                    </Hidden>

                    <Grid item xs={12} sm={10}>
                        { content }
                    </Grid>

                    <Hidden only={["xs", "sm"]}>
                        <Grid item sm={1}></Grid>
                    </Hidden>
                </Grid>
            </div>       
        )
    }
}

export default DataVisualizer

// const styledPageSelector = withStyles(styles)(PageSelector)

/*
const mapStateToProps = state => ({
    pathname: state.router.location.pathname
})

function mapDispatchToProps(dispatch) {
    return { 
        actions: {
            pushToUrl: bindActionCreators(push, dispatch)
        }
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DataVisualizer)
*/


// WEBPACK FOOTER //
// ./src/components/pages/shared/DataVisualizer.js